var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultitrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 2.5H3.33268C2.40768 2.5 1.66602 3.24167 1.66602 4.16667V14.1667C1.66602 15.0833 2.40768 15.8333 3.33268 15.8333H6.66602V17.5H13.3327V15.8333H16.666C17.5827 15.8333 18.3327 15.0833 18.3327 14.1667V4.16667C18.3327 3.24167 17.5827 2.5 16.666 2.5ZM16.666 14.1667H3.33268V4.16667H16.666V14.1667Z",
    fill: "#FF3D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.87504H11.6667V8.12504H5V6.87504ZM13.75 8.12504H15V6.87504H13.75V5.83337H12.5V9.16671H13.75V8.12504ZM8.33333 10.2084H15V11.4584H8.33333V10.2084ZM6.25 12.5H7.5V9.16671H6.25V10.2084H5V11.4584H6.25V12.5Z",
    fill: "#FF3D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultitrack);
export default __webpack_public_path__ + "static/media/multitrack.c6bf11a1c315a7c5e2b2c9705971ab80.svg";
export { ForwardRef as ReactComponent };